module.exports = __webpack_public_path__ + "media/svg-new/019-question 3-59ad618d.svg";